/**
 * Mensaje claro cuando falla la subida de un archivo.
 *
 * El caso que más confunde: el servidor web que está delante de la API (nginx) rechaza el archivo
 * por tamaño con un 413 ANTES de que llegue a la aplicación. Esa respuesta no lleva cabeceras
 * CORS, así que el navegador la bloquea y axios la ve como «sin respuesta»: el usuario leía
 * «conexión caída» cuando en realidad el archivo era más grande que el límite del servidor (1 MB
 * por defecto en nginx). Si no hay respuesta y el archivo pasa de 1 MB, se dice eso y qué pedir.
 *
 * @param {any} error   error de axios
 * @param {File|File[]} [archivos] lo que se intentó subir (para el tamaño)
 */
const LIMITE_NGINX_POR_DEFECTO = 1024 * 1024;

export const describirErrorSubida = (error, archivos) => {
  const lista = (Array.isArray(archivos) ? archivos : [archivos]).filter(Boolean);
  const bytes = lista.reduce((t, f) => t + (Number(f.size) || 0), 0);
  const mb = bytes ? ` (${(bytes / (1024 * 1024)).toFixed(1)} MB)` : "";
  const status = error?.response?.status;
  const data = error?.response?.data;
  const delServidor = typeof data === "object" && data ? data.error || data.message : null;

  if (delServidor && !/^ERR_/.test(String(delServidor))) return String(delServidor);
  if (status === 413) {
    return `El archivo${mb} supera el límite de subida del servidor. Pide al administrador que amplíe «client_max_body_size» en nginx (por ejemplo, a 100M).`;
  }
  if (status === 415) return "Tipo de archivo no permitido";
  if (status === 401 || status === 403) return "La sesión caducó: vuelve a iniciar sesión y reintenta";
  if (error?.code === "ECONNABORTED") {
    return `La subida${mb} tardó demasiado y se canceló. Revisa la conexión o prueba con un archivo más pequeño.`;
  }
  if (!error?.response) {
    if (bytes > LIMITE_NGINX_POR_DEFECTO) {
      return `El servidor rechazó el archivo${mb} antes de procesarlo. Lo más probable es el límite de tamaño de subida del servidor web (nginx «client_max_body_size», 1 MB por defecto): pide al administrador que lo amplíe (por ejemplo, a 100M).`;
    }
    return "No hubo respuesta del servidor. Revisa tu conexión e inténtalo de nuevo.";
  }
  return `Error al subir el archivo (HTTP ${status})`;
};

export default describirErrorSubida;
